import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from 'assets/url/urls';
import { LoginService } from '../../login/login.service';
import { Observable } from 'rxjs';
import { UserCalendarStatsView } from 'app/model/userCalendarStats';

@Injectable({
  providedIn: 'root'
})
export class UserCalendarStatsService {
  private readonly REST_API_SERVER = `${urls.baseUrl}/user_calendar_stats`
  private readonly HEADERS = new HttpHeaders({
    'X-TENANT-ID': urls.tenant,
    'Authorization': 'Bearer ' + this.loginService.getToken()
  })

  /**
   * Constructor
   *
   * @param {HttpClient} http
   * @param {LoginService} loginService
   * 
  */
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  public getUserCalendarStatsViewByEmployeeIdAndYear(employeeId: number, year: number): Observable<UserCalendarStatsView> {
    const headers = this.HEADERS

    return this.http.get<UserCalendarStatsView>(`${this.REST_API_SERVER}/view/${employeeId}/${year}`, { headers })
  }
}
